/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Shortage_Warning_TitleInputs */

const vi_packaging_shortage_warning_title = /** @type {(inputs: Packaging_Shortage_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cảnh báo thiếu tồn kho vật tư`)
};

/**

* @param {Packaging_Shortage_Warning_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_shortage_warning_title = /** @type {((inputs?: Packaging_Shortage_Warning_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Shortage_Warning_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_shortage_warning_title(inputs)
});